const SortButton = document.getElementById('SortBtn');

if(SortButton){
  document.getElementById('SortBtn').addEventListener('click', function() {
      this.classList.toggle('active_SortList');
      let sortList = document.getElementById('SortList');
      
      if (sortList.style.display === "none" || sortList.style.height === "0px") {
          sortList.style.display = "block";
          let height = sortList.scrollHeight + "px";
          sortList.style.height = "0px";
          setTimeout(() => {
              sortList.style.height = height;
          }, 10);
      } else {
          sortList.style.height = "0px";
          sortList.addEventListener('transitionend', () => {
              sortList.style.display = "none";
          }, { once: true });
      }
  });
}



// document.querySelectorAll('.collection_filter .filter_item .label').forEach(function(label) {
//     label.addEventListener('click', function() {
//         let parentFilterItem = this.closest('.filter_item');

//         if (parentFilterItem.classList.contains('active_label')) {
//             parentFilterItem.classList.remove('active_label');

//             let nextUl = this.nextElementSibling;
//             if (nextUl && nextUl.tagName === 'UL') {
//                 nextUl.style.display = 'none';
//             }
//         } else {
//             document.querySelectorAll('.collection_filter .filter_item').forEach(function(item) {
//                 item.classList.remove('active_label');
//             });

//             parentFilterItem.classList.add('active_label');

//             document.querySelectorAll('.filter_item ul').forEach(function(ul) {
//                 ul.style.height = '0px';
//                 ul.style.display = 'none';
//             });

//             let nextUl = this.nextElementSibling;
//             if (nextUl && nextUl.tagName === 'UL') {
//                 nextUl.style.display = 'block'; 
//                 let height = nextUl.scrollHeight + 'px';
//                 nextUl.style.height = '0px'; 
//                 setTimeout(function() {
//                     nextUl.style.height = height;
//                 }, 5000);

//                 nextUl.addEventListener('transitionend', function() {
//                     nextUl.style.height = 'auto';
//                 }, { once: true });
//             }
//         }
//     });
// });


document.querySelectorAll('.collection_filter .filter_item .label').forEach(function(label) {
    label.addEventListener('click', function() {
        let parentFilterItem = this.closest('.filter_item');

        if (parentFilterItem.classList.contains('active_label')) {
            // Remove active class and close the filter
            parentFilterItem.classList.remove('active_label');

            let nextUl = this.nextElementSibling;
            if (nextUl && nextUl.tagName === 'UL') {
                let height = nextUl.scrollHeight + 'px';  // Get the current height for smooth transition
                nextUl.style.height = height;  // Set height explicitly before collapsing

                // Use a timeout to allow the browser to apply the initial height before collapsing
                setTimeout(function() {
                    nextUl.style.height = '0px';
                }, 10); // A small delay to allow the initial height to be set
            }
        } else {
            // Remove active class from other filter items
            document.querySelectorAll('.collection_filter .filter_item').forEach(function(item) {
                item.classList.remove('active_label');
            });

            parentFilterItem.classList.add('active_label');

            // Collapse all other ULs
            document.querySelectorAll('.filter_item ul').forEach(function(ul) {
                ul.style.height = '0px'; // Close all
            });

            // Open the clicked one
            let nextUl = this.nextElementSibling;
            if (nextUl && nextUl.tagName === 'UL') {
                let height = nextUl.scrollHeight + 'px';  // Get full height
                nextUl.style.height = height;  // Expand the UL
                nextUl.style.display = 'block';  // Make sure it's visible

                // Once the transition completes, set the height to 'auto' to allow dynamic content growth
                nextUl.addEventListener('transitionend', function() {
                    nextUl.style.height = 'auto';
                }, { once: true });
            }
        }
    });
});


const variantLabels = document.querySelectorAll('.varint_label');
if(variantLabels.length > 0){  
  variantLabels.forEach(function(label) {
    label.addEventListener('change', function() {
      variantLabels.forEach(function(label) {
        if(variantLabels.length > 0){          
          const removevalue = label.querySelector('input');
          removevalue.removeAttribute("checked");
        }
      })
      const value = label.querySelector('input');
      value.setAttribute("checked", "checked");
    });
  });
}



 document.addEventListener('DOMContentLoaded', function() {
  const thumbnails = document.querySelectorAll('.product__thumbnail');
  thumbnails.forEach(function(thumbnail, index) {
    thumbnail.addEventListener('click', function() {
      const mediaItems = document.querySelectorAll('.product__media-item');
      mediaItems.forEach(function(item) {
        item.classList.remove('active');
      });
      mediaItems[index].classList.add('active');
    });
    document.querySelector('.product__media-item').classList.add('active');
  });
});

// toggle wishlist icon
const wishlistImage = document.querySelectorAll('.wish_img');
if(wishlistImage.length > 0){
  wishlistImage.forEach(icon=>{
    icon.addEventListener('click', ()=>{
      var closestWishlistMainIcon = '';
      if(icon.closest('.iWishAdd')){        
        closestWishlistMainIcon = icon.closest('.iWishAdd');
      } else{
        closestWishlistMainIcon = icon.closest('.iWishAddColl');
      }
      setTimeout(()=>{    
        if(closestWishlistMainIcon.classList.contains('iwishAdded')){ 
          if(!icon.classList.contains('selected')){          
            icon.classList.add('selected');
          }
        } else{
          icon.classList.remove('selected');        
        }
      }, 100);
    })
  })
}


document.addEventListener("DOMContentLoaded", function () {
  // Select all elements with the class 'details'
  const detailsElements = document.querySelectorAll(".menu-drawer__menu .details");

  detailsElements.forEach((details) => {
    const menuIcon = details.querySelector(".menu_ic");

    menuIcon.addEventListener("click", function () {
      // Toggle the 'open' class on the details div
      details.classList.toggle("open");
    });
  });
});


             